"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Separator = void 0;

var _react = _interopRequireDefault(require("react"));

var _nikeDesignSystemComponents = require("@nike/nike-design-system-components");

/**
 * @name Separator
 * @description Component which renders separator between any components.
 * @returns {JSX.Element}
 * @memberof mfe-inline-cookie
 */
var Separator = function Separator() {
  return /*#__PURE__*/_react.default.createElement(_nikeDesignSystemComponents.Box, {
    "data-testid": "separator",
    backgroundColor: "rgb(229,229,229)",
    height: "1px"
  });
};

exports.Separator = Separator;